import React from 'react';
import { useTranslation } from 'react-i18next';

/**
 * FiltroBusqueda
 * Props:
 * - value: string (valor del input)
 * - onChange: function (handler para input)
 * - placeholder: string (placeholder del input)
 * - title: string (opcional, título del filtro)
 * - showSelect: bool (si muestra el select integrado)
 * - selectOptions: array (opciones del select)
 * - selectValue: string (valor del select)
 * - onSelectChange: function (handler del select)
 * - selectPlaceholder: string (placeholder del select)
 * - showButton: bool (si muestra el botón de filtros)
 * - onButtonClick: function (handler del botón)
 * - buttonLabel: string (texto del botón)
 * - buttonIcon: string (src del icono)
 * - className: string (clases extra)
 * - children: node (para añadir selects/labels extra con clases consistentes)
 */
const FiltroBusqueda = ({
  value,
  onChange,
  placeholder,
  title = '',
  selectOptions = null,
  selectValue = '',
  onSelectChange = null,
  selectPlaceholder,
  showSelect = false,
  showButton = false,
  onButtonClick = null,
  buttonLabel,
  buttonIcon = null,
  className = '',
  children,
  showInput = true,
  onClose = null
  , showFooter = false,
  onReset = null,
  resetText
}) => {
  const { t } = useTranslation();
  const textoPlaceholder = placeholder ?? t('comun.buscarPlaceholder');
  const textoSelectPlaceholder = selectPlaceholder ?? t('comun.seleccionarPlaceholder');
  const textoBoton = buttonLabel ?? t('comun.filtros');
  const textoReset = resetText ?? t('comun.reset');
  return (
    <div className={`filtro-busqueda ${className}`.trim()}>
      {title && (
        <div className="filtro-header">
          <h3 className="filtro-titulo">{title}</h3>
          {/* botón de cierre inline: se renderiza solo si se pasa onClose */}
          {typeof onClose === 'function' && (
            <button className="close-inline" onClick={onClose} aria-label={t('comun.cerrarFiltro')}>×</button>
          )}
        </div>
      )}
      {showInput && (
        <input
          type="text"
          placeholder={textoPlaceholder}
          value={value}
          onChange={e => onChange(e.target.value)}
        />
      )}
      {showSelect && selectOptions && (
        <label className="filtro-label">
          <select
            className="filtro-select"
            value={selectValue}
            onChange={e => onSelectChange(e.target.value)}
          >
            <option value="">{textoSelectPlaceholder}</option>
            {selectOptions.map((opt, idx) => (
              <option key={idx} value={opt.value || opt}>{opt.label || opt}</option>
            ))}
          </select>
        </label>
      )}
      {children}
      {showButton && (
        <button className="btn-filtros" onClick={onButtonClick} type="button">
          {buttonIcon && <img src={buttonIcon} alt="" />}
          {textoBoton}
        </button>
      )}
      {/* Footer opcional: botón fijo de reseteo */}
      {showFooter && (
        <div className="filtro-footer">
          <button className="boton-reset-filtros" onClick={onReset} type="button">{textoReset}</button>
        </div>
      )}
    </div>
  );
};

export default FiltroBusqueda;
